<template>

    <RouterLink :to="props.route" class="no-link-style">
        <div :class="['panel', panelStatusClass]">
            <div :class="['icon-container', iconStatusClass]">
                <InlineSvg :src="props.icon" :width="32" :height="32" />
            </div>
            <div class="content">
                <div class="title">{{ props.title }}</div>
                <div class="description">{{ props.description }}</div>
            </div>
            <div :class="['status-pill', pillStatusClass]">{{ props.status }}</div>
        </div>
    </RouterLink>
</template>

<script setup>
import { defineProps, computed } from 'vue'
import InlineSvg from 'vue-inline-svg'

const props = defineProps({
    title: String,
    description: String,
    status: String,
    icon: Object,
    route: String,
})


const iconStatusClass = computed(() => {
    switch (props.status) {
        case 'In Progress':
            return 'purpleBg-Green'
        case 'In Review':
            return 'purpleBg-Green'
        case 'Not Started':
            return 'pinkBG-Green'
        case 'Successfully Completed':
            return 'blueBg-Green'
        case 'Completed':
            return 'blueBg-Green'
        case 'Closed':
            return 'blueBg-Green'
        default:
            return ''
    }
})

const panelStatusClass = computed(() => {
    switch (props.status) {
        case 'Successfully Completed':
            return 'light-green-bg'
        case 'Closed':
            return 'light-green-bg'
        case 'Completed':
            return 'light-green-bg'
        default:
            return ''
    }
})

const pillStatusClass = computed(() => {
    switch (props.status) {
        case 'Successfully Completed':
            return 'complete'
        case 'Completed':
            return 'complete'
        case 'Closed':
            return 'complete'
        case 'In Progress':
            return 'in-progress'
        case 'In Review':
            return 'in-progress'
        case 'Not Started':
            return 'not-started'
        case 'Overdue':
            return 'overdue'
        default:
            return ''
    }
})
</script>
